import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, IconButton } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';

import useTimeline from '../timeline/useTimeline';
import { DropdownFilter } from './DropdownFilter';
import { DayNightSwitch } from './DayNightSwitch';
import { getCurrentUserOrgUnits } from '../../../actions/entities';
import { updateFilters } from '../../../actions/areas/dailyPlanning/filters';
import { bandsEndpoint } from '../../../settings/constants';
import { getSelectorOptions } from '../../../actions/uiElements/selectors';
import { getOrgUnitTeams } from '../../../actions/areas/planner/queryActions';
import _ from './../../../utils/lodash';

export function Filters({ bands, toggleAdvancedFilters }) {
  const dispatch = useDispatch();
  const [filterState, setFilterState] = useState({});
  const [filterData, setFilterData] = useState(null);
  const selectedOrgUnit = useSelector(state => state.areas.dailyPlanning.filters.selectedTeam);
  const selectedOrgUnitTeam = useSelector(state => state.areas.dailyPlanning.filters.orgUnitTeam);
  const selectedBand = useSelector(state => state.areas.dailyPlanning.filters.grades);
  const selectedDate = useSelector(state => state.areas.dailyPlanning.selectedDate);
  const settingList = useSelector(store => store.global.auth.settings);
  const enableMappingOfTeamsSetting = _.find(settingList, 'EnableMappingOfTeams');
  const enableMappingOfTeams = _.values(enableMappingOfTeamsSetting)[0] === 'true';
  const { setFlagAndClinician, getAccessToken } = useTimeline();

  function resetFilters(filter) {
    setFilterState({
      ...filterState,
      ...filter,
    });
  }

  useEffect(() => {
    Promise.all([
      dispatch(getCurrentUserOrgUnits(selectedDate)),
      dispatch(getSelectorOptions(bandsEndpoint, 'bands')),
    ]).then(([filterData1, filterData2]) => {
      setFilterData(prev => ({
        ...prev,
        filterData1,
        filterData2,
      }));
      const orgUnits = filterData1 ? filterData1.response.data.options : [];
      if (selectedOrgUnit === null && orgUnits.length > 0) dispatch(updateFilters({ selectedTeam: orgUnits[0].id }));
      if (enableMappingOfTeams) {
        getOrgUnitTeams(getAccessToken, selectedOrgUnit || orgUnits[0].id, false, orgUnitTeams => {
          setFilterData(prev => ({ ...prev, orgUnitTeams }));
        });
      }
    });
  }, [selectedDate]);

  function setFilterValue(filter, value) {
    setFilterState({
      ...filterState,
      [filter]: value,
    });

    if (filter === 'orgUnit') {
      resetFilters({ clinician: '', grades: [''], orgUnitTeam: [''] });
      dispatch(updateFilters({ selectedTeam: value, clinician: '', grades: [''], orgUnitTeam: '' })).then(() => {
        if (enableMappingOfTeams) {
          getOrgUnitTeams(getAccessToken, value, false, orgUnitTeams => {
            setFilterData({
              ...filterData,
              orgUnitTeams,
            });
          });
        }
      });
    } else if (filter === 'clinician') {
      resetFilters({ grades: [''] });
      dispatch(updateFilters({ [filter]: value, grades: [''] }));
    } else dispatch(updateFilters({ [filter]: value }));
    setFlagAndClinician('showClinicianDetails', false, 0, 0, ['showClinicianTreatments', 'enableMultipleSelection']);
  }

  const orgUnitOptions = filterData && filterData.filterData1 ? filterData.filterData1.response.data.options : [];
  const orgUnitTeamOptions =
    enableMappingOfTeams && filterData && filterData.orgUnitTeams ? filterData.orgUnitTeams : [];
  return (
    <section className="filter-wrapper">
      <Box display="flex" flexWrap="nowrap" p={0}>
        <Box p={0.5} flexGrow={0}>
          <IconButton size="small" onClick={toggleAdvancedFilters}>
            <FilterListIcon style={{ color: '#8F8F8F', paddingTop: '3px' }} />
          </IconButton>
        </Box>
        <Box p={0.5} flexGrow={1}>
          {filterData && (
            <DropdownFilter
              dropdownId="orgUnitFilter"
              labelId="selectedOrgUnit"
              fullWidth
              data={orgUnitOptions}
              defaultValue={orgUnitOptions.length > 0 ? [orgUnitOptions[0].id] : ''}
              filterKey={'orgUnit'}
              filterValue={selectedOrgUnit || filterState.orgUnit}
              onChange={(name, value) => setFilterValue(name, value)}
            />
          )}
        </Box>

        {filterData && enableMappingOfTeams && (
          <Box p={0.5} flexGrow={1}>
            <DropdownFilter
              dropdownId="orgUnitTeamFilter"
              labelId="orgUnitTeam"
              fullWidth
              data={orgUnitTeamOptions}
              defaultValue={['']}
              filterKey={'orgUnitTeam'}
              filterValue={selectedOrgUnitTeam || filterState.orgUnitTeam}
              hasAny
              onChange={(name, value) => setFilterValue(name, value)}
            />
          </Box>
        )}

        <Box p={0.5} flexGrow={1}>
          {filterData && (
            <DropdownFilter
              fullWidth
              data={bands || []}
              filterKey={'grades'}
              defaultValue={['']}
              hasAny
              multiple
              filterValue={selectedBand || filterState.grades}
              onChange={(name, value) => setFilterValue(name, value)}
            />
          )}
        </Box>

        <Box p={1} flexGrow={0}>
          <DayNightSwitch />
        </Box>
      </Box>
    </section>
  );
}
